import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import ProductCollapseDesktop from './ProductCollapseDesktop';
import ProductDetailDesktop from './ProductDetailDesktop';
import ProductTicket from '../productTicket/ProductTicket';
import ProductMessage from '../ProductMessage';

import { getImage } from '../../../../../redux/actions/ImageActions';

const ProductContainerDesktop = ({ ...props }) => {
  const { product, index, tickets } = props;
  const dispatch = useDispatch();
  const [productTickets, setProductsTickets] = useState([]);
  const [mouseOver, setIsMouseOver] = useState(false);

  const handleIsOen = (event) => {
    if (event === 'panel1' && !product.thumbnailImage) {
      dispatch(getImage(product.sku));
    }
  };

  useEffect(() => {
    setProductsTickets(
      tickets.filter(
        (ticket) =>
          ticket.orderId === product.orderId.toString() &&
          ticket.sku === product.sku,
      ),
    );
  }, [tickets]);

  return (
    <Box
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <ProductCollapseDesktop
        name={product.name}
        totalPrice={product.totalPrice}
        purchaseDate={product.purchaseDate}
        index={index}
        isMkp={product.isMkp}
        isOpen={handleIsOen}
        somethingBelow={productTickets.length || product.nc}
        mouseOver={mouseOver}
      >
        <ProductDetailDesktop
          thumbnailImage={product.thumbnailImage}
          sku={product.sku}
          orderId={product.orderId}
          quantity={product.quantity}
          purchaseState={product.purchaseState}
          dispatch={product.dispatch}
          isMkp={product.isMkp}
          billImage={product.billImage}
          errorTracking={product.errorTracking}
          tickets={productTickets}
          source={product.source}
          urlNc={product.urlNc}
          totalPrice={product.totalPrice}
          name={product.name}
          purchaseDate={product.purchaseDate}
        />
      </ProductCollapseDesktop>
      {product.nc && (
        <ProductMessage type="nc" rounded={productTickets.length === 0} />
      )}
      {productTickets.length > 0 && <ProductTicket tickets={productTickets} />}
    </Box>
  );
};

ProductContainerDesktop.propTypes = {
  product: PropTypes.object,
  index: PropTypes.number,
  tickets: PropTypes.array,
};

export default ProductContainerDesktop;
